import { render, staticRenderFns } from "./ReadImage.vue?vue&type=template&id=2066437e&"
import script from "./ReadImage.vue?vue&type=script&lang=ts&"
export * from "./ReadImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports